/**
 * The design system's sticker inventories (ROUND3 §3, D39): registered for
 * rendering, and listed by the redrawn Stickers tray only. The flag-off
 * gallery lists `WIDGET_PRESETS`, which these never join.
 */

export { EMOJI_FACE, EMOJI_SECTIONS } from "./emojiSections";
export type { EmojiEntry, EmojiSection } from "./emojiSections";
export { ICON_STICKER_PRESETS, ICON_STICKER_SIZE } from "./IconSticker";
export { REVIEW_STICKER_PRESETS } from "./ReviewSticker";

import { ICON_STICKER_PRESETS } from "./IconSticker";
import { REVIEW_STICKER_PRESETS } from "./ReviewSticker";

export const DS_STICKER_PRESETS = [
  ...REVIEW_STICKER_PRESETS,
  ...ICON_STICKER_PRESETS,
];
